/* eslint-disable no-unused-vars */
import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { MdOutlineKeyboardArrowRight } from 'react-icons/md';
import AppSelect from '../../../shared/components/app-select/AppSelect';
import AppLink from '../../../shared/components/app-link/AppLink';
import './ClientCommissions.scss';
import {
  getClientCommissionsApi,
  getDmtBookings,
} from '../../../api/profileApi';

const COMMISSION_TYPE = [
  { label: 'Flights Domestic', value: 'FlightsDomestic' },
  { label: 'Flights International', value: 'FlightsInternational' },
  { label: 'Hotels Domestic', value: 'HotelsDomestic' },
  { label: 'Hotels International', value: 'HotelsInternational' },
];

function ClientCommissions() {
  const navigate = useNavigate();
  const [commissionType, setCommissionType] = useState('FlightsDomestic');
  const [showFilters, setShowFilters] = useState(false);
  const [commissionList, setCommissionList] = useState([]);
  const [hasCommissions, setHasCommissions] = useState(false);
  const getClientCommissions = async () => {
    const response = await getClientCommissionsApi(commissionType);
    if (response.Root?.Status === 'OK') {
      if (response.Root.Result?.AgentCommissionsNew) {
        const { AgentCommissionsNew } = response.Root.Result;
        const list = Array.isArray(AgentCommissionsNew)
          ? AgentCommissionsNew
          : [AgentCommissionsNew];
        setCommissionList(list);
        setHasCommissions(true);
      }
    } else {
      setHasCommissions(false);
    }
  };

  useEffect(() => {
    setCommissionList([]);
    getClientCommissions();
  }, [commissionType]);
  return (
    <section className="client-commissions-page py-4">
      <div className="d-flex align-items-center gap-1 fs-14 fw-600 mb-2 train-search-container">
        <AppLink linkText="Accounts" onClick={() => navigate(-1)} />
        <MdOutlineKeyboardArrowRight className="fs-5" />
        <span>Client Commissions</span>
      </div>
      <div className="client-commissions-page_container">
        <div className="client-commissions-page_header">
          All Flight Commissions
        </div>
        <div className="client-commissions-page_header_content">
          <div className="d-flex justify-content-between p-3 select-div">
            <AppSelect
              name="commissionType"
              label="Select Type"
              placeholder="Commission Type"
              options={COMMISSION_TYPE}
              selectedValue={commissionType}
              onSelect={(dataObj) => setCommissionType(dataObj.value)}
              isClearable={false}
            />
            <AppLink
              variant="primary"
              linkText="Show/Hide Filters"
              onClick={() => setShowFilters(!showFilters)}
            />
          </div>
        </div>
      </div>
      {hasCommissions ? (
        commissionList.map((item) => (
          <div
            key={`${item.servicetype}__${item.carrier}_${item.priority}`}
            className="client-commissions-page_content mt-2 max-width"
          >
            <div className="py-2 px-1">
              <div>
                Supplier : <span>{item.supplier}</span> Carrier :{' '}
                <span>{item.carrier}</span> Service type :{' '}
                <span>{item.servicetype}</span> Priority:{' '}
                <span>{item.priority}</span>
              </div>
            </div>
            <div className="mb-3">
              <table border="1" className="w-100">
                <tbody>
                  <tr>
                    <td>{}</td>
                    <td>BaseFare</td>
                    <td>YQ</td>
                    <td>Tax</td>
                    <td>YR</td>
                    <td>Flat</td>
                  </tr>
                  <tr>
                    <td>Service Tax</td>
                    <td>{item.servicetax_bf}</td>
                    <td>{item.servicetax_yq}</td>
                    <td>{item.servicetax_tax}</td>
                    <td>{item.servicetax_yr} Commission</td>
                    <td>{item.servicetax_handlingcharges} Handling Charges</td>
                  </tr>
                  <tr>
                    <td>Discount</td>
                    <td>{item.commission_bf}</td>
                    <td>{item.commission_yq}</td>
                    <td>{item.commission_tax}</td>
                    <td>{item.commission_yr}</td>
                    <td>{item.commission_flat}</td>
                  </tr>
                  <tr>
                    <td>Handling Charges</td>
                    <td>{item.handlingcharges_bf}</td>
                    <td>{item.handlingcharges_yq}</td>
                    <td>{item.handlingcharges_tax}</td>
                    <td>{item.handlingcharges_yr}</td>
                    <td>{item.handlingcharges_flat}</td>
                  </tr>
                  <tr>
                    <td>Transaction Fee</td>
                    <td>{item.transactionfee_bf}</td>
                    <td>{item.transactionfee_yq}</td>
                    <td>{item.transactionfee_tax}</td>
                    <td>{item.transactionfee_yr}</td>
                    <td>{item.transactionfee_flat}</td>
                  </tr>
                  <tr>
                    <td>PLB CutandPay</td>
                    <td>{item.plbcutnpay_bf}</td>
                    <td>{item.plbcutnpay_yq}</td>
                    <td>{item.plbcutnpay_tax}</td>
                    <td>{item.plbcutnpay_yr}</td>
                    <td>{item.plbcutnpay_flat}</td>
                  </tr>
                  <tr>
                    <td>PLB Post Pay</td>
                    <td>{item.plbpostpay_bf}</td>
                    <td>{item.plbpostpay_yq}</td>
                    <td>{item.plbpostpay_tax}</td>
                    <td>{item.plbpostpay_yr}</td>
                    <td>{item.plbpostpay_flat}</td>
                  </tr>
                  <tr>
                    <td>TDS</td>
                    <td colSpan="2">On Discount {item.tds_commission}</td>
                    <td>{}</td>
                    <td>{}</td>
                    <td>{}</td>
                  </tr>
                  <tr>
                    <td>Cancellation Fee</td>
                    <td colSpan="4">
                      Adult {item.cancellationfee_adult} Child{' '}
                      {item.cancellationfee_child} Infant{' '}
                      {item.cancellationfee_infant}
                    </td>
                    <td>{item.cancellationfee_overallflat}</td>
                  </tr>
                  <tr>
                    <td>Reschedule Fee</td>
                    <td colSpan="4">
                      Adult {item.reschedulefee_adult} Child{' '}
                      {item.reschedulefee_child} Infant{' '}
                      {item.reschedulefee_infant}
                    </td>
                    <td>{item.reschedulefee_overallflat}</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        ))
      ) : (
        <div className="client-commissions-page_content p-3 max-width mt-2">
          No Commissions Found
        </div>
      )}
    </section>
  );
}

export default ClientCommissions;
